import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICommunityPropertiesInitialState, IResponseDictionary } from './interfaces';

const initialState: ICommunityPropertiesInitialState = {
  responses: {},
};

const communityPropertiesSlice = createSlice({
  name: 'communityProperties',
  initialState,
  reducers: {
    setCommunityResponses(state, action: PayloadAction<IResponseDictionary>) {
      state.responses = action.payload;
    },
  },
});

export const { setCommunityResponses } = communityPropertiesSlice.actions;
export const communityPropertiesReducer = communityPropertiesSlice.reducer;
